import { SettingsLayout } from '@/features/settings/SettingsLayout';
import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/settings')({
  staticData: { nav: 'settings' },
  component: SettingsLayout,
});
